export default __webpack_public_path__ + "static/media/loadingImage.082de0df.gif";